import React, {RefObject, useContext} from 'react';

type Dictionary = Record<string, any>;
export const initialState: FilterContextState = {
  renderSplit: false,
  shouldOpenTipToApply: false,
  order: [] as string[],
  disabled: false,
  initialAppliedFilters: {} as Dictionary,
  appliedFilters: {} as Dictionary,
  shownFilters: {} as Dictionary,
  tempFilters: {} as Dictionary,
  anchorEl: null,
  addChipRef: null,
  openFilter: '',
};

const actions: FilterContextActions = {
  handleSetTempValue: (id: string, tempValue: any) => {
    return;
  },
  handlePopperClose: () => {
    return;
  },
  handleRemoveFilter: (id: string) => {
    return;
  },
  handleChangeFilter: (id: string, value: any) => {
    return;
  },
  handleAddFilter: (id: string, initialValue: any) => {
    return;
  },
  handleRemoveAllFilters: () => {
    return;
  },
  handleChipFilterClick: (id: string) => (el: HTMLElement) => {
    return;
  },
  setState: (state: Partial<typeof initialState>) => {
    return;
  },
  tryOpenTipToApply: () => {
    return null;
  },
  addChangeFilterListener: (callback: (id: string, isAdding: boolean, value: any) => void) => {
    return;
  },
  addRemoveFilterListener: (callback: (id: string) => void) => {
    return;
  },
  scrollbarsRef: null,
};

export type FilterContextActions<Filters extends Dictionary = Dictionary> = {
  handleSetTempValue: <K extends keyof Filters>(id: K, tempValue: Filters[K]) => void;
  handlePopperClose: () => void;
  handleRemoveFilter: (id: string) => void;
  handleChangeFilter: <K extends keyof Filters>(id: K, value: Filters[K]) => void;
  handleAddFilter: <K extends keyof Filters>(id: K, initialValue: Filters[K]) => void;
  handleRemoveAllFilters: () => void;
  handleChipFilterClick: (id: string) => (el: HTMLElement) => void;
  setState: (state: Partial<FilterContextState<Filters>>) => void;
  tryOpenTipToApply: () => void;
  addChangeFilterListener: (callback: (id: string, isAdding: boolean, value: any) => void) => void;
  addRemoveFilterListener: (callback: (id: string) => void) => void;
  scrollbarsRef: RefObject<{}> | null;
};
export type FilterContextState<Filters extends Dictionary = Dictionary> = {
  renderSplit: boolean;
  shouldOpenTipToApply: boolean;
  order: string[];
  disabled: boolean;
  initialAppliedFilters: Partial<Filters>;
  appliedFilters: Partial<Filters>;
  shownFilters: Partial<Filters>;
  tempFilters: Partial<Filters>;
  anchorEl: HTMLElement | null;
  addChipRef: React.RefObject<HTMLElement> | null;
  openFilter: string;
};

export const FilterContext = React.createContext({
  ...initialState,
  ...actions,
});

export const useFilterContext = <Filters extends Dictionary = Dictionary>() => {
  return useContext(
    FilterContext as React.Context<FilterContextState<Filters> & FilterContextActions<Filters>>,
  );
};
